import { useSelector } from 'react-redux';
import services from '../../services/servicesTeso';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useMensajesStore } from '../Generales_Mensajes_Validaciones/useMensajesStore';
import { useAuthStore } from '../useAuthStore';


export const useUsersStore = () => {
    const navigate = useNavigate();
    const { user } = useSelector(state => state.auth);
    const { SuccessMensaje, SuccessMensajeSend, SuccessDeleteMensaje, abrirCargar, abrirCargarNoTiempo, cerrarLoading, ErrorMensaje } = useMensajesStore();
    const { checkAuthToken } = useAuthStore();


    let userId = sessionStorage.getItem('uid');

    //Actualiza e inserta bancos. 
    const UpsertUserInfoData = async ({
        id,
        name,
        lastName,
        email,
        company_id,
        telefono,
        estadoProvincia,
        nomnbre_empresa,
        description,
        address,
        code_postal,
        company_phone,
        company_email
    }) => {
        //debugger

        const token = localStorage.getItem('token');

        checkAuthToken();
        try {
            let data = [];
            const headerAxios = {
                'content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
            
            data = await axios.post(services.API.User.UpdateData, {
                id,
                name,
                lastName,
                email,
                company_id,
                telefono,
                estadoProvincia,
                nomnbre_empresa,
                description,
                address,
                code_postal,
                company_phone,
                company_email
            }, { headers: headerAxios });

            if (data.data.respuesta === "success") {
                console.log("data: " + data);
                SuccessMensaje();
            }
            if (data.data.respuesta === "warning") {
                Swal.fire(
                    'Error',
                    'Contacte el administrador.',
                )
            }
        } catch (error) {
            console.log("error:" + error);
            ErrorMensaje();
        }
    }

    //Get Data to update.
    const getDataUpdateUser = async () => {
        //debugger
        const token = localStorage.getItem('token');
        checkAuthToken();
        try {
            const headerAxios = {
                'content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
            abrirCargar();
            const { data } = await axios.get(services.API.User.GetData, { headers: headerAxios });
            if (data.respuesta === "success") {
                return data.Data
            }
        } catch (error) {
            console.log("error:" + error);
        }
    }


    return {
        //* Métodos
        UpsertUserInfoData,
        getDataUpdateUser,
    }

}